const FOCUSABLE_CANDIDATE_SELECTOR = "a[href], button, input, select, textarea, [tabindex]";
function isFocusableCandidate(element) {
  return !element.hasAttribute("disabled") && element.getAttribute("tabindex") !== "-1";
}
export function queryFocusableCandidates(root) {
  return Array.from(root.querySelectorAll(FOCUSABLE_CANDIDATE_SELECTOR)).filter(isFocusableCandidate);
}
export function queryRovingTabindexItems(root) {
  return Array.from(root.querySelectorAll(FOCUSABLE_CANDIDATE_SELECTOR)).filter(element => !element.hasAttribute("disabled"));
}
export function findFirstFocusableCandidate(root) {
  return queryFocusableCandidates(root)[0];
}
function isVisible(element) {
  return element.getClientRects().length > 0 && !element.closest("[hidden]");
}
export function getFocusableElements(root) {
  return queryFocusableCandidates(root).filter(isVisible);
}